import { render } from "./IndexPage.vue?vue&type=template&id=0ce2bbf8"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"

import "./IndexPage.vue?vue&type=style&index=0&id=0ce2bbf8&lang=css"

import exportComponent from "/vercel/path0/bindex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__